import React, { Component } from 'react';

const SearchBar = ({ posts, setSearchResults }) => {
    const handleSubmit = (e) => e.preventDefault()

    const handleSearchChange = (e) => {
        if (!e.target.value) return setSearchResults(posts)

        const resultsArray = posts.filter(post => post.name.toLowerCase().includes(e.target.value.toLowerCase()))

        setSearchResults(resultsArray)
    }

    return (
            <form className="search" onSubmit={handleSubmit} style={{float: "left", marginLeft: "30px"}}>
                <input
                    className="search__input"
                    type="text"
                    id="search"
                    placeholder="Search..."
                    onChange={handleSearchChange}
                />
            </form>
    )
}
export default SearchBar